import inf_scroll from './inf_scroll.vue';
import { add_bs_met_if_not_exists } from '@/functions/general.js';
export default {
  components:{inf_scroll},
  data(){
    return {
      checked_get:false,
      is_intersecting:false,
    }
  },
  created(){
    let path = this.name.split('-');
    const name = path[path.length-1];
    path.pop();
    const pre_name = path;
    pre_name.unshift('inf');
    add_bs_met_if_not_exists(`${name}/a/all`,pre_name.join('-'),this.$store,['gets']);
    this.checked_get = true;
  },
  methods: {
    endIntersect(entries, observer, isIntersecting) {
      this.is_intersecting = isIntersecting;
    }
  },
};
